import React, { Component, ReactNode } from 'react';
import './CredibilityMeterScale.scss';
import { MeterSelectBar } from './MeterSelectBar';

interface CredibilityMeterScaleProps {
  start: number;
  end: number;
  onChange?: (value: number) => void;
  className?: string;
}

interface CredibilityMeterScaleState {
  selectedIndex: number;
}

export class CredibilityMeterScale extends Component<CredibilityMeterScaleProps, CredibilityMeterScaleState> {
  state = {
    selectedIndex: -1,
  };

  handleSelect = (index: number, actualValue: number): void => {
    const currentSelectedIndex = this.state.selectedIndex;
    let newSelectedIndex = index;
    if (currentSelectedIndex === index) {
      newSelectedIndex = -1;
    }
    this.setState({ selectedIndex: newSelectedIndex });
    if (this.props.onChange) {
      this.props.onChange(actualValue);
    }
  };

  render(): ReactNode {
    const { start, end, className } = this.props;
    const { selectedIndex } = this.state;
    const fullClassName = `credibility-meter-scale ${className ? className : ''}`;
    const range = (end - start) + 1;
    const middle = (end / 2);

    return (
      <div className={fullClassName}>
        <div className="credibility-meter-scale__container">
          <div className="credibility-meter-scale__bar">
            {
              [...Array<void>(range)].map((_: any, i: number) => <MeterSelectBar
                key={i}
                selected={selectedIndex === i}
                number={start + i}
                onSelect={() => this.handleSelect(i, start + i) }
                style={{ filter: `saturate(${(100 / range) * (i + 1)}%)` }}
                className={`${start + i > middle ? 'meter-select-bar--blue' : '' || start + i === middle ? 'meter-select-bar--gradient' : '' || start + i < middle ? 'meter-select-bar--orange' : ''}`}
              />)
            }
          </div>
          <div className="credibility-meter-scale__tips">
            <div>Ongeloofwaardig</div>
            <div>Neutraal</div>
            <div>Geloofwaardig</div>
          </div>
        </div>
      </div>
    );
  }
}
